import { fetchData } from '@umu/umu-fetch';
import API from '../../path';

/**
 * @desc 导航名称 枚举
 */
enum NAV_NAME {
    __INIT__ = '', // 自定义导航
    NAME_INDEX = 'index', // 首页
    NAME_COURSE = 'course', // 课程
    NAME_MESSAGE = 'message', // 消息
    NAME_PERSONAL_CENTER = 'personal_center', // 个人中心
    NAME_MY_TODO = 'my_todo', // 我的待办
    NAME_LEARNING_TASK = 'learning_task', // 学习任务
    NAME_DEPARTMENT_BOARD = 'department_board', // 部门看板
    NAME_LEARNING_CIRCLE = 'learning_circle', // 学习圈
    NAME_USHOW = 'ushow',
    NAME_CHATBOT = 'chatbot',
    NAME_DAILY_QUIZ = 'daily_quiz', // 每日一考
    NAME_MY_COLLECTION = 'my_collection', // 我的收藏
    NAME_MY_CLASS = 'my_class', // 我的班级
}
// 功能开关
enum NAV_ENABLE_STATUS {
    DISABLE,
    ENABLE,
}
/**
 * @desc 导航行信息
 */
interface INavigationItemInfo {
    id: string;
    name: NAV_NAME;
    default_title?: string;
    path: string;
    is_enabled: NAV_ENABLE_STATUS;
    can_preview: NAV_ENABLE_STATUS;
    can_close: NAV_ENABLE_STATUS;
    can_edit_path: NAV_ENABLE_STATUS;
    icon: INavigationItemIcon;
    pc_icon: INavigationItemIcon;
    title: Record<string, string>;
}
/**
 * @desc 导航图标配置信息
 */
interface INavigationItemIcon {
    svg?: {
        normal_url: string;
        normal_color: string;
        icon_name: string;
        selected_url: string;
        selected_color: string;
    };
    custom?: {
        normal_url: string;
        selected_url: string;
    };
}

/**
 * @desc 内置接口页面类型
 */
enum NavigationPageType {
    USE_NAVIGATION, // USE用户导航配置
    APP_NAVIGATION = 1, // App导航配置
}
const navApiMap = {
    [NavigationPageType.USE_NAVIGATION]: {
        getAi: API.USE_NAVIGATION_LIST,
        setApi: API.SET_USE_NAVIGATION_LIST,
    },
    [NavigationPageType.APP_NAVIGATION]: {
        getAi: API.APP_NAVIGATION_LIST,
        setApi: API.SET_APP_NAVIGATION_LIST,
    },
};

/**
 * @desc 获取导航列表 依据页面类型
 */
interface INavigationInfo {
    list: INavigationItemInfo[];
    title_selected_color?: string;
}
const getNavigationListByPageType = (
    pageType = NavigationPageType.USE_NAVIGATION,
    params = {},
): Promise<INavigationInfo> => {
    const api = navApiMap[pageType];
    if (!api) {
        return Promise.resolve({
            list: [],
        });
    }
    return fetchData(api.getAi, params, { silent: true }).then(
        (res: IResponse<INavigationInfo>) => {
            return (
                res?.data || {
                    list: [],
                }
            );
        },
        () => {
            return {
                list: [],
            };
        },
    );
};

const onTransformUseIcon = (icon: INavigationItemIcon): INavigationItemIcon => {
    const isCustom = Object(icon).hasOwnProperty('custom');
    const { svg, custom } = icon;
    if (isCustom) {
        return {
            custom: {
                normal_url: custom?.selected_url || '',
                selected_url: custom?.selected_url || '',
            },
        };
    }
    return {
        svg: {
            normal_url: svg?.normal_url || '',
            normal_color: svg?.selected_color || '',
            icon_name: svg?.icon_name || '',
            selected_url: svg?.selected_url || '',
            selected_color: svg?.selected_color || '',
        },
    };
};
const setNavigationListByPageType = (
    list: INavigationItemInfo[],
    paramsInfo = {},
    pageType = NavigationPageType.USE_NAVIGATION,
): Promise<{ isSuccess: boolean }> => {
    const isUse = pageType === NavigationPageType.USE_NAVIGATION;
    const params = JSON.stringify({
        ...paramsInfo,
        list: list.map((item) => {
            const { name, is_enabled, title, path, icon, pc_icon } = item;
            const newIcon = isUse ? onTransformUseIcon(icon) : icon;
            return {
                name,
                is_enabled,
                title,
                path,
                icon: newIcon,
                [isUse ? 'pc_icon' : '']: onTransformUseIcon(pc_icon),
            };
        }),
    });
    const api = navApiMap[pageType];
    if (!api) {
        return Promise.resolve({ isSuccess: false });
    }
    return fetchData(api.setApi, params, { silent: true }).then(
        (res: { data: { status: number } }) => {
            return { isSuccess: !!res.data.status };
        },
        () => {
            return { isSuccess: false };
        },
    );
};
export {
    NAV_NAME,
    INavigationInfo,
    NAV_ENABLE_STATUS,
    INavigationItemInfo,
    INavigationItemIcon,
    NavigationPageType,
    getNavigationListByPageType,
    setNavigationListByPageType,
};
